<template>
  <div class="licence">
      <div class="title">增值电信业务经营许可证</div>
      <img src="../assets/images/licence.jpg" alt="">
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {

    },
    mounted(){

    }
  }
</script>

<style scoped lang="less">
.licence{
  width:1000px;
  margin:20px auto;
  text-align: center;
  .title{
    font-size: 30px;
    margin-bottom: 20px;
    line-height: 50px;
    border-bottom: 1px solid #333;
  }
  img{
    width:600px;
  }
}
</style>



// WEBPACK FOOTER //
// Licence.vue?777ad7aa